var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcPaymentInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "write"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 1.25C3.48858 1.25 1.25 3.48858 1.25 6.25V33.75C1.25 36.5114 3.48858 38.75 6.25 38.75H28.75C31.5114 38.75 33.75 36.5114 33.75 33.75V6.25C33.75 3.48858 31.5114 1.25 28.75 1.25H6.25ZM27.5 8.75H8.75V12.5H27.5V8.75ZM27.5 17.5H8.75V21.25H27.5V17.5ZM8.75 26.25H27.5V30H8.75V26.25Z",
    fill: "url(#paint0_linear_12058_106282)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1099 36.25C13.2892 36.25 13.2892 36.25 13.4684 36.25L17.5916 35.5233C19.3843 35.16 20.9977 34.2516 22.2525 32.9799L36.5939 18.6276L38.3866 16.6291C39.4622 15.7208 40 14.2674 40 12.814C40 11.3606 39.4622 10.0889 38.3866 8.99882C36.4147 7.00039 33.0086 7.00039 30.8574 8.99882L29.0647 10.8156L14.7233 25.1679C13.4684 26.4396 12.5721 28.0746 12.2136 29.8914L11.3172 34.0699C11.138 34.6149 11.3172 35.3416 11.855 35.705C12.2136 36.0683 12.5721 36.25 13.1099 36.25ZM33.3671 11.7239C34.0842 10.9972 35.1598 10.9972 35.8769 11.7239C36.4147 12.0873 36.4147 12.6323 36.4147 12.814C36.4147 13.359 36.2354 13.7224 35.8769 14.0857L35.339 14.8124L32.8293 12.269L33.3671 11.7239Z",
    fill: "url(#paint1_linear_12058_106282)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12058_106282",
    x1: 17.5,
    y1: 1.25,
    x2: 17.5,
    y2: 38.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7F741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECA25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12058_106282",
    x1: 25.625,
    y1: 7.5,
    x2: 25.625,
    y2: 36.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#189EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3863D2"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcPaymentInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_payment_info.8f2971b0d7efb907919e6804f5767f0f.svg";